import { usePaginatedQuery, queryCache } from 'react-query';
import { ApplicationDispatch, SET_SERVER_MESSAGE } from '../store/application/types';
import { fetchData, postData } from './fetch';
import { useDispatch } from 'react-redux';
import { IApplicationDocument } from '../Interfaces/Application/IApplicationDocument';
import { IApplication } from '../Interfaces/Application/IApplication';
import {hasValue} from "@amsanalytics/react-shared-library";

export interface ITextMessage {
  id: number;
  phoneNumberFrom?: string;
  phoneNumberTo?: string;
  message?: string;
  json?: string;
  deleted?: boolean;
  createdDate?: string;
  createdDateFormatted?: string;
  modifiedDate?: string;
  applicationId?: string;
  application?: IApplication;
  applicationDocuments?: IApplicationDocument[];
  fromLos?: boolean;
  hasBeenViewed?: boolean;
}

export interface QueryTextMessages {
  applicationId?: string,
  pageNumber?: number;
  pageSize?: number;
}

export const useTextMessages = (params: QueryTextMessages) => {
  const dispatch = useDispatch<ApplicationDispatch>();
  
  const getTextMessages = async (key: string, params: QueryTextMessages) => {
    try {
      const searchParams = new URLSearchParams();
      for (let key in params) {
          let value = (params as any)[key];
          if (!value && value !== false) {
              value = '';
          }
          searchParams.set(key,  value);
      }

      // If both of these are null, it will grab EVERY text message, not paged, and not even use it in most cases
      // Added this check to make sure that it was going to make a legit call
      if (hasValue(params.applicationId) || hasValue(params.pageSize)) {
        const url = `api/textmessage/list/${params.applicationId || ''}?${searchParams.toString()}`;
        const data = await fetchData(url, dispatch);
        const total: number = data.total;
        const pageNumber: number = data.pageNumber;
        const textMessages: ITextMessage[] = data.result;
        return {total, pageNumber, textMessages};
      }
      return { total: 0, pageNumber: 0, textMessages: [] };
    } catch (err) {
      dispatch({
          type: SET_SERVER_MESSAGE,
          payload: { isError: true, message: err as string }
      });
      return { total: 0, pageNumber: 0, textMessages: [] };
    }
  }

  return usePaginatedQuery(
    ['TextMessages', params],
    getTextMessages,
    {
      refetchOnWindowFocus: false,
      refetchInterval: 15_000, 
    }
  )
}

export const assignTextMessageToApplication = async (textMessageId: number, applicationId: string) => {
  const url = `api/textmessage/${textMessageId}/assign/${applicationId}`;
  const response = await postData(url, {});
  await queryCache.refetchQueries('TextMessages');
  return response;
}

export const sendTextMessage = async (toNumber: string, textMessage: string, applicationId: string, dispatch: ApplicationDispatch) => {
  const url = `api/textmessage/send?toNumber=${encodeURIComponent(toNumber)}&textMessage=${encodeURIComponent(textMessage)}&applicationId=${encodeURIComponent(applicationId)}`;
  const response = await postData(url, {});
  if (response.error) {
    dispatch({
      type: SET_SERVER_MESSAGE,
      payload: { isError: true, message: response.error },
    });
  }
  await queryCache.refetchQueries('TextMessages');
  return response;
}

export const viewTextMessagesForApplication = async (applicationId: string, dispatch: ApplicationDispatch) => {
  try {
  const url = `api/textmessage/viewForApplication/${applicationId}`;
  const response = await postData(url, {});
  await queryCache.refetchQueries('TextMessages');
  return response;
  } catch (err) {
    dispatch({
      type: SET_SERVER_MESSAGE,
      payload: { isError: true, message: err as string }
    });
  }
}
